import { useQuery } from "@tanstack/react-query";
import $api from "@/zapi-frontend/shared/api/axios";
import { useOrganizationStore } from "@/zapi-frontend/stores/organization";

type TFeatureFlagKey =
  | "enhanced-password-policy"
  | "two-factor-auth"
  | "labs-mode"
  | "no-logs"
  | "allow-empty-password"
  | "default-private-projects"
  | "case-brief-flag"
  | "us-residency"
  | "value-chain"
  | "claude-code-generation"
  | "rqa-sim"
  | "case-brief-document-reading"
  | "redesign";
type TFeatureFlags = Record<TFeatureFlagKey, boolean>;

const FEATURE_FLAGS_QUERY_KEY = "organization-feature-flags";

export function useFeatureFlags(organizationId?: number) {
  const { currentOrganizationId } = useOrganizationStore();
  const orgId = organizationId ?? currentOrganizationId;

  return useQuery<TFeatureFlags>({
    queryKey: [FEATURE_FLAGS_QUERY_KEY, orgId],
    queryFn: async () => {
      const params = orgId ? { organizationId: orgId } : {};
      const response = await $api.get("/organizations/feature-flags", { params });
      return response?.data ?? {};
    },
    enabled: !!orgId,
    staleTime: 5 * 60 * 1000
  });
}

export function useFeatureFlag(key: TFeatureFlagKey, organizationId?: number): boolean | undefined {
  const { data: flags, isLoading } = useFeatureFlags(organizationId);
  if (isLoading) return;
  return flags?.[key] ?? false;
}
